import { graphql } from '../../graphql/generated';

export const SheetEditorParameterFragment = graphql(`
  fragment SheetEditor_Parameter on Parameter {
    id
    shortName
    longName
    deactivated
    synonyms
    lab {
      id
      shortName
    }
  }
`);
